<div class="d-flex justify-content-center">
<h4 id="page-heading">
  <span>Aujourd'hui</span>
</h4>
</div>
<div class="container">
  <div class="d-flex justify-content-center">
    <div class="p-2">
      <circle-progress
      subtitle='Taux Occupation'
      [percent]="this.currentPeriodStats?.txOccupation"
      [innerStrokeColor]="(this.currentPeriodStats?.txOccupation >= 66)?'#c7e596':
      (this.currentPeriodStats?.txOccupation >=15) ?'#ffd080':'#ff6666'"
      [outerStrokeColor]="(this.currentPeriodStats?.txOccupation >= 66)?'#78c000':
      (this.currentPeriodStats?.txOccupation >=15) ?'orange':'#fb0e0e'">
      </circle-progress>
    </div>
    <div class="p-2 align-self-center">
      <svg width="200" height="100">
        <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
        <text x="100" y='20' font-size="25"
        [attr.fill]="(this.currentPeriodStats?.nbPlaceBusy >= 66)?'#78c000':
          (this.currentPeriodStats?.nbPlaceBusy >=15) ?'orange':'#fb0e0e'"
          text-anchor='middle'>{{this.currentPeriodStats?.nbPlaceEmpty}} / {{this.currentPeriodStats?.nbPlaceBusy}}</text>
          <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Places disponibles</text>
      </svg>
    </div>
    <div class="p-2 align-self-center">
      <svg width="200" height="100">
        <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
        <text x="100" y='20' font-size="25"
        [attr.fill]="'#148f29'" text-anchor='middle'>{{meanTimeHourM}} min</text>
        <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Durée stationnement moyen</text>
      </svg>
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="p-3 align-self-center">
        <!-- <svg width="200" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="'#148f29'" text-anchor='middle'>{{nbParkMonth}}</text>
          <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Nb stationnement</text>
        </svg> -->
    </div>
  </div>
  <div class="d-flex justify-content-center">
    <div class="p-2">
      <svg width="300" height="100">
        <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
        <text x="100" y='20' font-size="25"
        [attr.fill]="
        (this.nbParkForDay >= 66)?'#78c000':
        (this.nbParkForDay >= 15)?'orange':'#fb0e0e'"
          text-anchor='middle'>{{nbFps}}</text>
          <text x="100" y='65' font-size="16"
          fill="#000044"
          text-anchor='middle'>Nombre FPS</text>
      </svg>
    </div>
    <div class="p-2 align-self-center">
      <svg width="200" height="100">
        <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
        <text x="100" y='20' font-size="25"
        [attr.fill]="(this.currentPeriodStats?.nbPlaceBusy >= 66)?'#78c000':
          (this.currentPeriodStats?.nbPlaceBusy >=15) ?'orange':'#fb0e0e'"
          text-anchor='middle'>{{this.depacementMoyen}} min</text>
          <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Temps dépassement moyen</text>
      </svg>
    </div>
    <div class="p-2 align-self-center">
      <svg width="300" height="100">
        <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
        <text x="100" y='20' font-size="25"
        [attr.fill]="
        (this.nbParkForDay >= 66)?'#78c000':
        (this.nbParkForDay >= 15)?'orange':'#fb0e0e'"
          text-anchor='middle'>{{nbParkForDay}}</text>
          <text x="100" y='65' font-size="16"
          fill="#000044"
          text-anchor='middle'>Nb de stationnement </text>
      </svg>
    </div>
  </div>
</div>
<!-- mois encours -->
<div class="d-flex justify-content-center">
  <h4 id="page-heading">
    <span>Mois encours</span>
  </h4>
  </div>
  <div class="container">
    <div class="d-flex justify-content-center">
      <!-- <div class="p-2 align-self-center">
        <svg width="300" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="
          (this.nbParkForDay >= 66)?'#78c000':
          (this.nbParkForDay >= 15)?'orange':'#fb0e0e'"
            text-anchor='middle'>{{nbParkForDay}}</text>
            <text x="100" y='65' font-size="16"
            fill="#000044"
            text-anchor='middle'>Nb de stationnement </text>
        </svg>
      </div> -->
      <div class="p-3 align-self-center">
          <svg width="200" height="100">
            <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
            <text x="100" y='20' font-size="25"
            [attr.fill]="'#148f29'" text-anchor='middle'>{{nbParkMonth}}</text>
            <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Nb stationnement</text>
          </svg>

          <svg width="200" height="100">
            <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
            <text x="100" y='20' font-size="25"
            [attr.fill]="'#148f29'" text-anchor='middle'>{{meanTimeHourDay}} min</text>
            <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Durée stationnement moyen</text>
          </svg>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="p-2">
        <svg width="300" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="
          (this.nbParkForDay >= 66)?'#78c000':
          (this.nbParkForDay >= 15)?'orange':'#fb0e0e'"
            text-anchor='middle'>{{nbFpsM}}</text>
            <text x="100" y='65' font-size="16"
            fill="#000044"
            text-anchor='middle'>Nombre FPS</text>
        </svg>
      </div>
      <div class="p-2 align-self-center">
        <svg width="200" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="(this.currentPeriodStats?.nbPlaceBusy >= 66)?'#78c000':
            (this.currentPeriodStats?.nbPlaceBusy >=15) ?'orange':'#fb0e0e'"
            text-anchor='middle'>{{this.depacementMoyenM}} min</text>
            <text x="100" y='65' font-size="16" fill="#000044" text-anchor='middle'>Temps dépassement moyen</text>
        </svg>
      </div>
      <div class="p-2 align-self-center">
        <svg width="300" height="100">
          <rect x="0" y="0" width="200" height="100" fill="#ffffff" />
          <text x="100" y='20' font-size="25"
          [attr.fill]="
          (this.nbParkForDay >= 66)?'#78c000':
          (this.nbParkForDay >= 15)?'orange':'#fb0e0e'"
            text-anchor='middle'>{{nbParkForDay}}</text>
            <text x="100" y='65' font-size="16"
            fill="#000044"
            text-anchor='middle'>Nb de dépassement </text>
        </svg>
      </div>
    </div>
  </div>
<div class="d-flex justify-content-center">
<h4 id="page-heading">
  <span>Historique</span>
</h4>
</div>
<!-- <div class="d-flex justify-content-center">
  <label class="p-2 align-self-center" for="date">Depuis le</label>
  <input matInput class="form-control col-5 mr-2" placeholder="Date" max="currentPeriod" (dateChange)="onFormChange()"
    [satDatepicker]="picker" name="date" [(ngModel)]="dateRange">

  <sat-datepicker startView='year' #picker [rangeMode]="false" panelClass="range-datepicker"
    [selectFirstDateOnClose]="true">
  </sat-datepicker>
  <sat-datepicker-toggle matSuffix [for]="picker">
  </sat-datepicker-toggle>
</div> -->
<div class="d-flex justify-content-center">
  <mat-form-field >
    <mat-label>Depuis le</mat-label>
    <input matInput class="form-control col-5 mr-2" max="currentPeriod" (dateChange)="onFormChange()" [(ngModel)]="dateRange" [matDatepicker]="picker">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>
<div class="d-flex flex-row">
<div class="p-2 chart-container" >
  <canvas baseChart [datasets]="chartHistoriqueEmployeeData" [(labels)]="labelsHistoriqueEmployee" [options]="historiqueEmployeeChartOptions" [plugins]="barChartPlugins"
  [chartType]="barChartType" [colors]="chartColors" >
  </canvas>
</div>
</div>
<div class="d-flex flex-row">
  <div class="p-2 chart-container" >
    <canvas baseChart [datasets]="chartHistoriqueCustomerData" [(labels)]="labelsHistoriqueCustomer" [options]="historiqueCustomerChartOptions" [plugins]="barChartPlugins"
    [chartType]="barChartType" [colors]="chartColors">
    </canvas>
  </div>
</div>
